<template>
    <div class="side-navigation">
        <div class="d4d-logo image-container"></div>
        <b-nav vertical :class="{'isCareerEntrep': isJACareerEntrepreApp}" class="nav-side-navigation mb-5">
            <b-nav-text :class="{'current': currentStep===2, 'disabled' : lastStep<2}">Deep Customer Empathy</b-nav-text>
            <b-nav-item   :class="{'disabled': lastStep<3, 'current': currentStep===3}" :disabled="(lastStep<3)"
                        :to="{ name: 'deep_customer_empathy_3', params: { index } }">Deep Customer Empathy Instructions
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<4, 'current': currentStep===4}" :disabled="(lastStep<4)"
                        :to="{ name: 'deep_customer_empathy_4', params: { index } }">Deep Customer Empathy Summary
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<5, 'current': currentStep===5}" :disabled="(lastStep<5)"
                        :to="{ name: 'deep_customer_empathy_5', params: { index } }">Customer Problem Statement
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<6, 'current': currentStep===6}" :disabled="(lastStep<6)"
                        :to="{ name: 'deep_customer_empathy_6', params: { index } }">Ideal State
            </b-nav-item>

            <b-nav-text :class="{'current': currentStep===7, 'disabled' : lastStep<7}">Go Broad to Go narrow</b-nav-text>

            <b-nav-item :class="{'disabled': lastStep<8, 'current': currentStep===8}" :disabled="(lastStep<8)"
                        :to="{ name: 'go_broad_to_go_narrow_8', params: { index } }">Go Broad Instructions
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<9, 'current': currentStep===9}" :disabled="(lastStep<9)"
                        :to="{ name: 'go_broad_to_go_narrow_9', params: { index } }">Go Broad Brainstorming Summary
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<10, 'current': currentStep===10}" :disabled="(lastStep<10)"
                        :to="{ name: 'go_broad_to_go_narrow_10', params: { index } }">Go Narrow Techniques
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<11, 'current': currentStep===11}" :disabled="(lastStep<11)"
                        :to="{ name: 'go_broad_to_go_narrow_11', params: { index } }">Go Narrow Summary
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<12, 'current': currentStep===12}" :disabled="(lastStep<12)"
                        :to="{ name: 'go_broad_to_go_narrow_12', params: { index } }">Go Narrow Sketch
            </b-nav-item>

            <b-nav-text :class="{'disabled' : lastStep<13, 'current': currentStep===13}">Rapid Experiments With Customers</b-nav-text>

            <b-nav-item :class="{'disabled': lastStep<14, 'current': currentStep===14}" :disabled="(lastStep<14)"
                        :to="{ name: 'rapid_experiments_with_customers_14', params: { index } }">Leap of Faith Assumptions
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<15, 'current': currentStep===15}" :disabled="(lastStep<15)"
                        :to="{ name: 'rapid_experiments_with_customers_15', params: { index } }">Types of Experiments
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<16, 'current': currentStep===16}" :disabled="(lastStep<16)"
                        :to="{ name: 'rapid_experiments_with_customers_16', params: { index } }">Experiment Plan
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<17, 'current': currentStep===17}" :disabled="(lastStep<17)"
                        :to="{ name: 'rapid_experiments_with_customers_17', params: { index } }">Experiment Instructions
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<18, 'current': currentStep===18}" :disabled="(lastStep<18)"
                        :to="{ name: 'rapid_experiments_with_customers_18', params: { index } }">Experiment Results
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<19, 'current': currentStep===19}" :disabled="(lastStep<19)"
                        :to="{ name: 'rapid_experiments_with_customers_19', params: { index } }">Next Steps
            </b-nav-item>
        </b-nav>
    </div>
</template>

<script>

    import navigation from '../../../core/Mixins/navigation'

    export default {
        name: "D4DNavigation",
        props: ['label'],
        mixins: [navigation],
    }
</script>

<style lang="stylus" scoped>
    @import "../Styles/d4d_styles.styl"
    .image-container
       background-color white

</style>
